<template>
    <v-card>
        <v-app-bar flat dark color="indigo">
            <v-toolbar-title>HISTORIAL DE ESTADOS - Ticket T-{{ idVenta }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeModal">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-app-bar>
        <v-card-text class="pa-4">
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-row dense align="center">
                    <v-col cols="12" sm="4">
                        <v-autocomplete
                            v-model="idEstado"
                            item-text="description"
                            item-value="id"
                            :items="listaEstados"
                            label="Seleccionar Estado"
                            :rules="[(v) => !!v || 'Seleccione un estado']"
                            required
                            dense
                            outlined
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="detalle"
                            label="Detalle (opcional)"
                            dense
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-btn :loading="loadingEstado" :disabled="!idEstado" @click="updateEstado" color="indigo" dark block>
                            <v-icon left>mdi-state-machine</v-icon> Actualizar Estado
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
            <v-divider class="my-4"></v-divider>
            <v-data-table
                :headers="headers"
                :items="historialEstado"
                :loading="loadingTable"
                class="elevation-1"
                :items-per-page="10"
                dense
            >
                <template v-slot:[`item.action`]="{ item }">
                    <v-icon small color="red" @click="confirmDelete(item)">mdi-delete</v-icon>
                </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="closeModal">
                <v-icon left small>mdi-close</v-icon> Cerrar
            </v-btn>
        </v-card-actions>
        <v-dialog v-model="openDialog" max-width="400">
            <v-card>
                <v-card-title class="text-h5">Confirmar eliminacion</v-card-title>
                <v-card-text>Se eliminara el registro del estado <b>{{ selectedRepart?.estado }}</b> del historial.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="openDialog = false">Cancelar</v-btn>
                    <v-btn color="red" text :loading="loadingDelete" @click="deleteEstado">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: {
        idVenta: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            valid: true,
            idEstado: null,
            detalle: '',
            loadingEstado: false,
            loadingTable: false,
            loadingDelete: false,
            openDialog: false,
            selectedRepart: null,
            headers: [
                { text: 'Estado', value: 'estado' },
                { text: 'Detalle', value: 'detalle' },
                { text: 'Fecha', value: 'fecha' },
                { text: 'Usuario', value: 'user' },
                { text: 'Acciones', value: 'action', sortable: false }
            ]
        }
    },
    computed: {
        ...mapState('inventario', ['historialEstado', 'listaEstados'])
    },
    async created() {
        this.loadingTable = true
        await this.$store.dispatch('inventario/estados')
        await this.$store.dispatch('inventario/getHistorialEstado', this.idVenta)
        this.loadingTable = false
    },
    methods: {
        async updateEstado() {
            if (!this.$refs.form.validate()) return
            this.loadingEstado = true
            try {
                await this.$store.dispatch('inventario/updateEstado', {
                    idEstado: this.idEstado,
                    idVenta: this.idVenta,
                    detalle: this.detalle
                })
                this.$root.$emit('refresh-reservas')
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'Estado actualizado correctamente',
                    color: 'success'
                })
                this.closeModal()
            } catch (error) {
                console.error('Error updating estado:', error)
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'Error al actualizar el estado',
                    color: 'red'
                })
            }
            this.loadingEstado = false
        },
        confirmDelete(item) {
            this.selectedRepart = item
            this.openDialog = true
        },
        async deleteEstado() {
            this.loadingDelete = true
            try {
                await this.$store.dispatch('inventario/deleteEstado', this.selectedRepart.id)
                await this.$store.dispatch('inventario/getHistorialEstado', this.idVenta)
                this.openDialog = false
                this.selectedRepart = null
                this.$root.$emit('refresh-reservas')
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'Registro eliminado del historial',
                    color: 'success'
                })
            } catch (error) {
                console.error('Error deleting estado:', error)
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'Error al eliminar el registro',
                    color: 'red'
                })
            }
            this.loadingDelete = false
        },
        closeModal() {
            this.$store.commit('ventas/SHOW_MODAL_HISTORIAL_ESTADO', false)
        }
    }
}
</script>
